import React from 'react';
import PropTypes from "prop-types";
import Ripples from 'react-ripples';

function Ripple({ duration, ...optionalProps}) {
    return <Ripples during={duration} {...optionalProps} />
}

Ripple.defaultProps = {
    duration: 1000
}

Ripple.propTypes = {
    duration: PropTypes.number
}

export default Ripple;
